module.exports = __webpack_public_path__ + "8afe4dc.ttf";